import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { PhxMonthPickerBodyComponent } from "./body/phx-month-picker-body.component";
import { PhxMonthPickerComponent } from "./month-picker-main/phx-month-picker.component";
import { PhxMonthPickerInputComponent } from "./month-picker-input/phx-month-picker-input.component";
import { PhxMonthPickerFooterComponent } from "./footer/phx-month-picker-footer.component";
import { PhxMonthPickerHeaderComponent } from "./header/phx-month-picker-header.component";
import { FormsModule } from "@angular/forms";
import { PhxTileModule } from "../tile/phx-tile.module";
import { PhxIconModule } from "../icon/icon.module";
import { PhxPipesModule } from "../pipes/phx-pipes.module";
import { PhxDropdownModule } from "../dropdown/phx-dropdown.module";
import { PhxButtonModule } from "../button/phx-button.module";
import { PhxIconButtonModule } from "../icon-button/phx-icon-button.module";

@NgModule({
  declarations: [PhxMonthPickerBodyComponent, PhxMonthPickerComponent, PhxMonthPickerInputComponent, PhxMonthPickerFooterComponent, PhxMonthPickerHeaderComponent],
  imports: [
    CommonModule,
    FormsModule,
    PhxTileModule,
    PhxIconModule,
    PhxPipesModule,
    PhxDropdownModule,
    PhxButtonModule,
    PhxIconButtonModule,
  ],
  exports: [PhxMonthPickerComponent, PhxMonthPickerBodyComponent, PhxMonthPickerInputComponent]
})
export class PhxMonthPickerModule { }
